/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { p as push } from '../../../index-ee2c9aee.js';
import '../../../index-892d8eee.js';

var mini = push;

export { mini as default };
